import { useEffect } from "react";
import { GroupChannel as GroupChannelType } from "@sendbird/chat/lib/__definition";
import { useSendbirdStateContext } from "@sendbird/uikit-react";

const LAST_CHANNEL_STORAGE_KEY = "werule.messages.lastChannelUrl";

export function persistLastChannelUrl(channelUrl: string | undefined) {
  if (!channelUrl) {
    return;
  }
  try {
    localStorage.setItem(LAST_CHANNEL_STORAGE_KEY, channelUrl);
  } catch {
    // Ignore storage failures (private mode, quota, etc.).
  }
}

export function useAutoSelectChannel(
  selectedChannel: GroupChannelType | null,
  onSelect: (channel: GroupChannelType) => void,
  enabled: boolean
) {
  const {
    stores: {
      sdkStore: { sdk },
    },
  } = useSendbirdStateContext();

  useEffect(() => {
    if (!enabled || selectedChannel || !sdk?.groupChannel?.createMyGroupChannelListQuery) {
      return;
    }

    let cancelled = false;

    const autoSelect = async () => {
      const savedUrl = (() => {
        try {
          return localStorage.getItem(LAST_CHANNEL_STORAGE_KEY);
        } catch {
          return null;
        }
      })();

      if (savedUrl) {
        try {
          const savedChannel = await sdk.groupChannel.getChannel(savedUrl);
          if (!cancelled && savedChannel) {
            onSelect(savedChannel);
            return;
          }
        } catch {
          // Fall through to most-recent channel.
        }
      }

      const query = sdk.groupChannel.createMyGroupChannelListQuery({
        limit: 30,
        includeEmpty: true,
      });
      const channels = await query.next();
      if (!cancelled && channels.length > 0) {
        onSelect(channels[0]);
      }
    };

    autoSelect().catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [enabled, onSelect, sdk, selectedChannel]);
}
